import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFPlainNumber } from "../../../Shared/NewForms/NFPlainNumber";
import { useTranslation } from "react-i18next";

const FixedAssetDetailDepreciationParameters = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("DepreciationStartingDate")} fieldName={"depreciationStartingDate"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("DepreciationMethod")} fieldName={"depreciationMethod"} />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("SalvageValue")} fieldName={"salvageValue"} />
        </Col>
        <Col sm={6}>
          <NFPlainNumber title={t("UsefulLife(month)")} fieldName={"usefulLife"} />
        </Col>
      </Row>

      <button type="button" className="btn btn-link">
        New Parameter
      </button>
      <button type="button" className="btn btn-link ">
        History
      </button>
    </>
  );
};

export default FixedAssetDetailDepreciationParameters;
